import _get from 'lodash/get';

import { CONTENT_PREFERENCE_CRITERIA } from './constants';

export const getContentPreference = (config, activeFilters = []) => {

    const availableFilterTabs = _get(config, 'filterGroups');

    const defaultContentPreference = _get(config, 'defaultFilterContentPreference');

    const getFilterPreferences = (filter) => {

        let contentPreferences = [];
        availableFilterTabs.forEach(tab => {

            tab.filters.forEach(filterConfig => {

                const preferences = filterConfig.fields.filter(field => field.id === filter.fieldId).map(field => field.contentPreference || defaultContentPreference);

                if (preferences.length > 0) {

                    contentPreferences.push(preferences);

                }

            });

        });

        return contentPreferences.reduce((a, b) => a.concat(b), []);

    };

    const isMixedContent = activeFilters.some(activeFilter => {

        return getFilterPreferences(activeFilter).some(contentPreference => contentPreference !== CONTENT_PREFERENCE_CRITERIA.cmsFirst);

    });

    return isMixedContent ? CONTENT_PREFERENCE_CRITERIA.mixed : CONTENT_PREFERENCE_CRITERIA.cmsFirst;

};
